import React from 'react';

import { throttle } from '@/utils';

interface Options {
  throttleBy?: number;
}

const useScrollPosition = (
  handleScroll: (event: UIEvent) => void,
  { throttleBy = 150 }: Options = {}
) => {
  const cachedHandleScroll = React.useRef(handleScroll);
  cachedHandleScroll.current = handleScroll;

  React.useEffect(() => {
    const throttled = throttle((event: UIEvent) => {
      cachedHandleScroll.current(event);
    }, throttleBy);

    window.addEventListener('scroll', throttled);

    return () => {
      window.removeEventListener('scroll', throttled);
    };
  }, [throttleBy]);
};

export default useScrollPosition;
